<template>
  <v-container class="shopping-cart p-0" fluid>
    <vue-headful :title="$t('header.shopping_cart') + $t('title')"></vue-headful>
    <HkiaraceBannerFrame :src="require('../../assets/acc.jpg')"
                         :label="$t('header.shopping_cart')"
                         no-transform-content>
      <v-container class="shopping-cart-content py-8 px-sm-8">
        <v-row class="font-size-70 text-right" v-if="shoppingCart && !shoppingCartExpired">
          <b-col>{{ $t('booking_preview.time_left') }} {{ timeLeft }}</b-col>
        </v-row>
        <v-row>
          <v-col>
            <v-data-table :items="bookings"
                          :headers="bookingHeaders"
                          mobile-breakpoint="0"
                          hide-default-footer>
              <template v-slot:item.start_time="{item}">
                <v-container fluid>
                  <v-row>
                    <v-col>
                      {{ $parseDate(item.start_time) }} - {{ $parseDate(item.end_time, 'HH:mm') }} {{ item.item.name }}
                    </v-col>
                  </v-row>
                  <v-row v-if="item.additional_items.length > 0">
                    <ul style="list-style-type: none;">
                      <li v-for="additional_item in item.additional_items">
                        {{ additional_item.type.name }} x {{ additional_item.count }}
                      </li>
                    </ul>
                  </v-row>
                </v-container>
                <!--                {{ facilityLabel(item) }}-->
              </template>
              <template v-slot:item.actions="{item}">
                <v-btn color="primary"
                       outlined
                       @click="removeBooking(item)">
                  {{ $t('booking_detail.cancel_booking') }}
                </v-btn>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <v-row class="text-right">
          <v-col>
            <v-btn color="primary"
                   :disabled="bookings.length === 0 || shoppingCartExpired"
                   @click="checkout">
              <v-img :src="require('../../assets/card.png')"
                     width="24px"
                     class="mr-2"></v-img>
              {{ $t('booking_preview.checkout') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </HkiaraceBannerFrame>
  </v-container>
</template>

<script>
import {library} from '@fortawesome/fontawesome-svg-core';
import {faCalendar, faChevronLeft, faChevronRight} from '@fortawesome/free-solid-svg-icons';
import HkiaraceBannerFrame from "../../components/HkiaraceBannerFrame";
import {ref, computed, watch, onMounted, onUnmounted} from "@vue/composition-api";
import {DateTime} from 'luxon';
import {BOOKING_RECORD_STATUS} from "@/constants";
import _ from 'lodash'

library.add(faCalendar, faChevronLeft, faChevronRight);

export default {
  name: 'ShoppingCart',
  components: {HkiaraceBannerFrame},
  setup(props, {root}) {
    onMounted(() => {
      root.$storeDispatch('getShoppingCart');
    });

    onUnmounted(() => {
      clearInterval(countDownInterval.value);
    })

    const shoppingCart = computed(() => root.$store.state.shoppingCart);
    watch(() => shoppingCart.value, (newValue) => {
      if (newValue && !countDownInterval.value) {
        countDownInterval.value = setInterval(calculateTimeLeft, 1000);
      }
    })

    // Count Down
    const countDownInterval = ref(null);
    const timeLeft = ref('10:00');
    const shoppingCartExpired = ref(false);
    const calculateTimeLeft = function () {
      let valid_until = null;
      if (shoppingCart.value.status === BOOKING_RECORD_STATUS.PENDING) {
        valid_until = DateTime.fromISO(shoppingCart.value.create_at).plus({minutes: 10});
      } else if (shoppingCart.value.status === BOOKING_RECORD_STATUS.PAYING) {
        valid_until = DateTime.fromISO(shoppingCart.value.payment_inited_at).plus({minutes: 30});
      }

      if (valid_until === null || DateTime.local() > valid_until) {
        clearInterval(countDownInterval.value);
        shoppingCartExpired.value = true;
      } else {
        let diff = valid_until.diff(DateTime.local(), ['minutes', 'seconds']);
        timeLeft.value = Math.floor(diff.minutes).toString().padStart(2, '0') + ":" + Math.floor(diff.seconds).toString().padStart(2, '0');
      }
    }

    // Bookings
    const bookings = computed(() => {
      if (shoppingCart.value) {
        return _.sortBy(shoppingCart.value.bookings, 'start_time');
      } else {
        return [];
      }
    })
    const bookingHeaders = ref([
      // {text: root.$t('booking.create_at'), value: 'create_at'},
      {text: root.$t('booking.facility'), value: 'start_time'},
      {text: '', value: 'actions', sortable: false, align: 'right'},
    ]);
    const facilityLabel = function (record) {
      return DateTime.fromISO(record.start_time).setLocale('en').toFormat('yyyy-MM-dd HH:mm') + ' - ' + DateTime.fromISO(record.end_time).toFormat('HH:mm') + "  " + record.item.name;
    };

    const removeBooking = function (item) {
      if (confirm(root.$t('booking_detail.cancel_booking_confirm_msg'))) {
        root.$callAPI('aafb/shopping_cart/remove/', {
          booking_id: item.id,
        }, () => {
          root.$storeDispatch('getShoppingCart');
        });
      }
    }

    const checkout = function () {
      root.$router.push({name: 'booking-preview', params: {bookingRecordId: shoppingCart.value.id}});
    }

    return {
      shoppingCart,

      countDownInterval,
      timeLeft,
      shoppingCartExpired,

      bookings,
      bookingHeaders,
      facilityLabel,
      removeBooking,
      checkout,

      parseDate: DateTime.fromISO,
    }
  },
}
</script>

<style lang="less">
.shopping-cart {
  .shopping-cart-content {
    background-color: white;


  }
}
</style>
